module.exports = __webpack_public_path__ + "0bbe5ea3cc8359d80199e0cfc6df417c.png";